import { createSlice } from "@reduxjs/toolkit";
import { fetchStateGovernmentDetails, getAllStateUsers } from "../thunk";

interface StateGovsState {
  stateGovs: any[];
  allStateGovs: {
    data: any[];
    pagination: {
      total: number;
      totalPages: number;
    };
  };
  status: string;
  error: string;
}

const initialState: StateGovsState = {
  stateGovs: [],
  allStateGovs: { data: [], pagination: { total: 0, totalPages: 0 } },
  status: "idle",
  error: "",
};

const stateGovSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateGovernmentDetails.pending, (state) => {
        state.status = "loading";
        state.error = "nil";
      })
      .addCase(fetchStateGovernmentDetails.fulfilled, (state, action) => {
        state.status = "success";
        const data = action.payload;
        state.stateGovs = data.map((item: any) => ({
          name: item.category,
          stateId: item._id,
          ministries: item.categoryType,
        }))
        state.error = "nil";
      })
      .addCase(fetchStateGovernmentDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Unknown error";
      })
      .addCase(getAllStateUsers.pending, (state) => {
        state.status = "loading";
        state.error = "nil";
      })
      .addCase(getAllStateUsers.fulfilled, (state, action) => {
        state.status = "success";
        const data = action.payload;
        state.allStateGovs = {
          data: data.data,
          pagination: {
            total: data.pagination.total,
            totalPages: data.pagination.totalPages,
          },
        };
        state.error = "nil";
      })
      .addCase(getAllStateUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error?.message || "Unknown error";
      });
  },
});

export default stateGovSlice.reducer;
